module.exports = __webpack_public_path__ + "media/images/favicons/32px-b5c118b52c8ce3f0f11794e14b59b2f2.png";